       $("body").on("click",".swatchItem",function(){

         let isChecked = $(this).is(':checked');
         if(isChecked == true){
           $(this).siblings('.add-on-product-note-wrp').slideDown();
         }else{
           $(this).siblings('.add-on-product-note-wrp').slideUp();
         }

       });
       $("body").on("click",".Custom-AddToCart3",function(){
           $('.addToCart-loader').addClass('active');
           addOn();
           setTimeout(function() {
             $( ".product-btn-wrp .btnAddToCart").each(function( index ) {
               if(index == 1){
                 $(this).trigger( "click" );
               }
             });
          }, 500);
       });


        $("body").on("click",".email-artwork-btn",function(){
            $('.addToCart-loader').addClass('active');
           addOn();
           setTimeout(function() {
             $( ".product-btn-wrp .btnAddToCart").each(function( index ) {
               if(index == 1){
                 $(this).trigger( "click" );
               }
             });
          }, 500);
       });

       $("body").on("click",".Custom-AddToCart2",function(){
           //$('.addToCart-loader').addClass('active');
           addOn();
           setTimeout(function() {
             $('.product-btn-wrp .btnAddToCart').trigger( "click" );
          }, 500);
	
       });

       function addOn(){
         let Quantity = $('#Quantity').val();
         jsonObj = [];
         $( ".add-on-products").each(function( index ) {
           var addOnDataID = $(this).children('input:checked').data('id');
           var addOnNote = $(this).find('.add-on-note').val();
           var addonFile = $(this).find("input[name='properties[thumbnail]']").val();
           if(addOnDataID){

              items = {}
              items ["id"] = addOnDataID;
              items ["quantity"] = Quantity;
               items ["properties"] = {
                'Note': addOnNote,
                 'image' : addonFile
              };
              jsonObj.push(items);
             
           }
            
          });       
    console.log(jsonObj);
         //setTimeout(function () {
          jQuery.post('/cart/add.js', {
        	   items:jsonObj
                
          },
          function (result) {
                
                    //$.cookie("addtoCartCount", addtoCartCount);
                    window.location.href = "/cart"  
            });
           
           //$( ".velaCartTop" ).trigger( "click" );
           //$("#cartDrawer").load();
         //}, 2500);
       }

        $(document).ready(function(){ 
               $("#Quantity").val(50);
             $('.know-more-about svg').click(function() {
           
              $(this).siblings('.add-on-popup-wrp').show();
           });
            $('.know-more-about .drawerClose').click(function() {
              $('.add-on-popup-wrp').hide();
           });
          
              $(".changeView.changeViewList").click(function(){
                if($("#velaProList .custom-list-view"))
                {
                  setTimeout(function () {  
                  $("#loading").css("display", "none");
                  },1000);
                }
              });
          $('.accordion-list > li > .answer').hide();
            
          $('.accordion-list > li h3').click(function() {
            if ($(this).parents('li').hasClass("active")) {
              $(this).parents('li').removeClass("active").find(".answer").slideUp();
            } else {
              $(".accordion-list > li.active .answer").slideUp();
              $(".accordion-list > li.active").removeClass("active");
              $(this).parents('li').addClass("active").find(".answer").slideDown();
            }
            return false;
          });
        
          // slide toggle
           $('.swatch-drop-down .js-swatch-display').click(function() {
             $(this).siblings('.swatch-wrp').slideToggle();
           });
          $('.swatch-drop-down label').click(function() {
             $(this).parents('.swatch-wrp').slideUp();
           });
        });
   

   
         function PriceCalculation(){

           var mainProPrice = $('.mainProPrice .priceProduct').text();
           
           mainProPrice = mainProPrice.trim(mainProPrice);
           const symbol = mainProPrice.charAt(0);
           $('.custom-price-tabel .column_price .proPrice').html(mainProPrice);
          
           var Qty_var = $("#Quantity").val();
            var price_without_currency = mainProPrice.replace(symbol,'');
            var price_without_currency = parseFloat(price_without_currency);
            var total_price = Qty_var*price_without_currency;
            var total_price = total_price.toFixed(2);
            var total_price = addCommas(total_price)
            $('.custom-price-tabel .column_totel').html(symbol+""+total_price);
            $(".mainProPrice.proPrice .total-price").remove();
            $(".mainProPrice.proPrice").prepend("<span class='total-price'>$"+total_price+"</span>");
           console.log('price calculatios======');
         }

         function addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        }
         
         $( document ).ready(function() {
           setTimeout(function() {
             $(".mainProPrice.proPrice").append("<span class='unit-lbl'>/ Unit</span>");
           }, 200);
           PriceCalculation();
           
            $("body").on("click",".tp-container .itier_price",function(){
              $('.tp-container .itier_price.selectable').removeClass('remove-select');
              $('.custom-price-tabel .itier_price.selectable').removeClass('active');
              setTimeout(function() {
                PriceCalculation();
              }, 200);
            });
          

/*
           $('.velaQtyAdjust').click(function() {
             setTimeout(function() {
               var Qty = $(this).siblings('input').val();
               alert(Qty);
                 if(Qty < 50){
                   
                   $(this).siblings('.velaQtyNum').val(50);
                 }
              }, 1000);
            });
            */
           $('.custom-price-tabel .itier_price.selectable').click(function() {
            //$("body").on("click",".custom-price-tabel .itier_price.selectable",function(){
               $('.tp-container .itier_price.selectable.active-option').addClass('remove-select');
              $(this).addClass('active');
            });

            $('.custom-price-tabel .velaQtyButton').click(function() {
                setTimeout(function() {
                   var Qty = $('#Quantity').val();
                   if(Qty < 50){
                     $('#Quantity').val(50);
                   }
                   PriceCalculation();
                }, 200);
            });

            jQuery('.velaQtyNum').on('input', function() {
           
               setTimeout(function() {
                  var Qty = $('#Quantity').val();
                 
                   if(Qty < 50){
                     $('#Quantity').val(50);
                   }
                  PriceCalculation();
                 $('.velaQtyPlus').trigger( "click" );
                 $('.velaQtyMinus').trigger( "click" );
                }, 500);
            });

            $('select').on('change', function (e) {
                setTimeout(function() {
                  PriceCalculation();
                  
                }, 200);
            });

           // Hide loader on shorting
           $('#SortBy').on('change', function (e) {
                $('.addToCart-loader').addClass('active');
                setTimeout(function() {
                  location.reload();
                 // var url      = window.location.href; 
                //alert(url);
                  
                  $('#loading').hide();
                }, 50);
             
                setTimeout(function() {
                  
                  $('#loading').hide();
                }, 500);
            });
         });

         $("body").on("click",".custom-cart-item",function(){
          /*
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 500);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 1000);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 1500);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 2000);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 2500);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 3000);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 4000);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 5000);
          setTimeout(function() {
              $('.btnUpdateCart.custombtnUpdateCart').trigger("click");
          }, 6000);
          */
        });

         $(document).ready(function(){ 
          var pageURL = $(location).attr("href");
          var pageURLarr = pageURL.split('?');
          var pageURLoutput=pageURLarr[1];
          
          
          var selected_product_variant = $('#selected-product-variant').val();
          //const selected_product_variantArray = selected_product_variant.split("/");
          // if(selected_product_variantArray[1]){
          //   selected_product_variant = selected_product_variantArray[1];
          //   selected_product_variant = $.trim(selected_product_variant);
          // }


          setTimeout(function() {
            $("#productSelect option").each(function(){
           
              if(selected_product_variant == $(this).text()){
                if(!pageURLoutput){
                  $('#productSelect').val($(this).val()).trigger('change');
                }
              }
             
            });
          }, 1000);
          
        setTimeout(function() {
          $("#productSelect option").each(function(){
           
              if(selected_product_variant == $(this).text()){
                if(!pageURLoutput){
                  $('#productSelect').val($(this).val()).trigger('change');
                }
              }
             
            });
        }, 1500);

          setTimeout(function() {
          $("#productSelect option").each(function(){
           
              if(selected_product_variant == $(this).text()){
                if(!pageURLoutput){
                  $('#productSelect').val($(this).val()).trigger('change');
                }
              }
             
            });
        }, 2000);
        });

        